import {
    select as D3select,
    dispatch as D3dispatch,
    scaleOrdinal as D3scaleOrdinal,
    scaleTime as D3scaleTime,
    scaleLinear as D3scaleLinear,
    extent as D3extent,
    area as D3area,
    curveMonotoneX as D3curveMonotoneX,
    brushX as D3brushX
} from 'd3';

// timeline area chart with a zoom brush overlay
const D3AreaChart = function () {
    const dispatch = D3dispatch('changed');

    // make room for axis
    const margin = { top: 0, right: 10, bottom: 6, left: 3 };

    // overrides defaults
    let color = D3scaleOrdinal();
    let dataservice = {
        timestamp: d => d.timestamp,
        count: d => d.count
    };
    let height = 40;
    let width = 100;
    let start;
    let end;

    function my (selction) {
        if (!selction) return;
        selction.each(function (data, i) {
            const xmin = start || (data.length > 0 ? dataservice.timestamp(data[0]) : new Date());
            const xmax = end || (data.length > 1 ? dataservice.end(data[data.length - 1]) : xmin);

            const x = D3scaleTime()
                .domain([xmin, xmax])
                .range([margin.left, width - margin.left - margin.right]);

            const y = D3scaleLinear()
                .domain(D3extent(data || [], dataservice.count))
                .range([height - margin.bottom - margin.top, margin.top]);

            const area = D3area().curve(D3curveMonotoneX)
                .x(d => x(dataservice.timestamp(d)))
                .y1(d => y(dataservice.count(d)))
                .y0(height - margin.bottom);

            const focusg = D3select(this);

            focusg.selectAll('path.timeline')
                .data([data])
                .join('path')
                .attr('class', 'timeline')
                .attr('fill', color)
                .style('pointer-events', 'none')
                .attr('d', area)
                .style('pointer-events', 'none');

            // zoom brush
            const brush = D3brushX()
                .extent([[0, 0], [x.range()[1], y.range()[0]]])
                .on('end', brushMoved);

            focusg.selectAll('g.brush').data(['once'])
                .join('g')
                .attr('class', 'brush invisibles')
                .call(brush);

            function brushMoved (e, d) {
                if (!e.selection) return;

                // outgoing time selection
                dispatch.call('changed', my, e.selection.map(x.invert));

                focusg.select('.brush').call(brush.move, null);
            }
        });
    }

    my.width = function (v) {
        if (!arguments.length) return width;
        width = v;
        return my;
    };

    my.height = function (v) {
        if (!arguments.length) return height;
        height = v;
        return my;
    };

    my.dataservice = function (v) {
        if (!arguments.length) return dataservice;
        dataservice = v;
        return my;
    };

    my.color = function (v) {
        if (!arguments.length) return color;
        color = v;
        return my;
    };

    my.start = function (v) {
        if (!arguments.length) return start;
        start = v;
        return my;
    };

    my.end = function (v) {
        if (!arguments.length) return end;
        end = v;
        return my;
    };

    my.on = function () {
        const value = dispatch.on.apply(dispatch, arguments);
        return value === dispatch ? my : value;
    };

    return my;
};

export default D3AreaChart;
